module.exports = __webpack_public_path__ + "img/DE00905.a19e07a5.png";